import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Error", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-xl mb-1" }, " There was problem while loading the Company Security Setup. Please try again. ", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl" }, "Loading Company Security Setup...", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x text-primary animated flash infinite slow mb-2" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-xl text-center" }, "Saving Company Security Setup...", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  id: "HosPal_New_Referral"
}
const _hoisted_14 = { class: "card-body form-content p-3 pt-0 mx-lg-6" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-center form-footer py-2 gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecurityAuthentication = _resolveComponent("SecurityAuthentication")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "has-buttons": true,
    "has-title": false,
    "content-class": "p-0",
    "has-page-scroll": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoadError || _ctx.isFormLoading || _ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.isLoadError && !_ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _hoisted_4,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCompanySecuritySetup()))
                  }, "Try Again")
                ]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isLoadError && _ctx.isFormLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
              : _createCommentVNode("v-if", true),
            (_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.isSignatureValidated)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_SecurityAuthentication, { securitySetup: _ctx.securitySetup }, null, 8 /* PROPS */, ["securitySetup"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (!_ctx.isLoadError && !_ctx.isFormLoading && !_ctx.isSaveInProgress)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
                  }, "Save"),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}